import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const DepositShrapIcon = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9443 13.4291V4H11.9443V13.4294L16.1818 9.19193L16.8889 9.89903L11.4445 15.3435L6 9.89903L6.70711 9.19193L10.9443 13.4291ZM18 19.0909H5V15H6V18.0909H17V15H18V19.0909Z"
      fill="currentColor"
    />
  </svg>,
  'DepositShrapIcon'
);
